var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"body",attrs:{"role":"main","id":"main"}},[_c('sc-placeholder',{attrs:{"tag":"section","rendering":_vm.rendering,"name":"locations-list-layout"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }